export default __webpack_public_path__ + "static/media/slider2.8634e862.jpg";